/**
 * Mobile menu toggle functionality
 */
export function initMobileMenu() {
	if (typeof jQuery === 'undefined') {
		return;
	}

	const $ = jQuery;

	$(document).ready(function() {
		var $mobileMenu = $('.mobile-menu');
		var $mobileMenuToggle = $('.mobile-menu-toggle');
		var $mobileMenuClose = $('.mobile-menu-close');

		// Open mobile menu
		$mobileMenuToggle.on('click', function(e) {
			e.preventDefault();
			$mobileMenu.addClass('is-open');
			$('body').addClass('mobile-menu-open');
			// Update ARIA attributes
			$mobileMenuToggle.attr('aria-label', 'Close menu');
			$mobileMenuToggle.attr('aria-expanded', 'true');
			$mobileMenuClose.attr('aria-expanded', 'true');
		});

		// Close mobile menu
		$mobileMenuClose.on('click', function(e) {
			e.preventDefault();
			$mobileMenu.removeClass('is-open');
			$('body').removeClass('mobile-menu-open');
			// Reset all accordions and dropdowns when closing
			resetMobileMenuState();
			// Update ARIA attributes
			$mobileMenuToggle.attr('aria-label', 'Open menu');
			$mobileMenuToggle.attr('aria-expanded', 'false');
			$mobileMenuClose.attr('aria-expanded', 'false');
		});

		// Close mobile menu when clicking outside
		$mobileMenu.on('click', function(e) {
			if ($(e.target).is($mobileMenu)) {
				$mobileMenu.removeClass('is-open');
				$('body').removeClass('mobile-menu-open');
				resetMobileMenuState();
				// Update ARIA attributes
				$mobileMenuToggle.attr('aria-label', 'Open menu');
				$mobileMenuToggle.attr('aria-expanded', 'false');
				$mobileMenuClose.attr('aria-expanded', 'false');
			}
		});

		// Accordion toggle functionality
		$('.mobile-menu-accordion-button').on('click', function(e) {
			e.preventDefault();
			var $button = $(this);
			var $item = $button.closest('.mobile-menu-accordion-item');
			var $content = $item.find('.mobile-menu-accordion-content');
			var $iconPlus = $button.find('.mobile-menu-accordion-icon-plus');
			var $iconMinus = $button.find('.mobile-menu-accordion-icon-minus');
			var isExpanded = $button.attr('aria-expanded') === 'true';

			if (isExpanded) {
				// Close
				$content.slideUp(300);
				$iconPlus.removeClass('hidden');
				$iconMinus.addClass('hidden');
				$button.attr('aria-expanded', 'false');
			} else {
				// Close other open accordions
				$('.mobile-menu-accordion-button[aria-expanded="true"]').each(function() {
					var $otherButton = $(this);
					var $otherItem = $otherButton.closest('.mobile-menu-accordion-item');
					var $otherContent = $otherItem.find('.mobile-menu-accordion-content');
					var $otherIconPlus = $otherButton.find('.mobile-menu-accordion-icon-plus');
					var $otherIconMinus = $otherButton.find('.mobile-menu-accordion-icon-minus');
					
					$otherContent.slideUp(300);
					$otherIconPlus.removeClass('hidden');
					$otherIconMinus.addClass('hidden');
					$otherButton.attr('aria-expanded', 'false');
				});

				// Open this one
				$content.slideDown(300);
				$iconPlus.addClass('hidden');
				$iconMinus.removeClass('hidden');
				$button.attr('aria-expanded', 'true');
			}
		});

		// Dropdown toggle functionality for header and footer buttons
		$('.mobile-menu-header-button, .mobile-menu-footer-button').on('click', function(e) {
			e.preventDefault();
			var $button = $(this);
			var dropdownType = $button.data('mobile-menu-dropdown');
			var $dropdown = $('.mobile-menu-dropdown-' + dropdownType);
			var $chevron = $button.find('img');
			var isExpanded = $button.attr('aria-expanded') === 'true';

			if (isExpanded) {
				// Close
				$dropdown.slideUp(300);
				$chevron.removeClass('rotate-180');
				$button.attr('aria-expanded', 'false');
			} else {
				// Close other open dropdowns
				$('.mobile-menu-header-button[aria-expanded="true"], .mobile-menu-footer-button[aria-expanded="true"]').each(function() {
					var $otherButton = $(this);
					var otherDropdownType = $otherButton.data('mobile-menu-dropdown');
					var $otherDropdown = $('.mobile-menu-dropdown-' + otherDropdownType);
					var $otherChevron = $otherButton.find('img');
					
					$otherDropdown.slideUp(300);
					$otherChevron.removeClass('rotate-180');
					$otherButton.attr('aria-expanded', 'false');
				});

				// Open this one
				$dropdown.slideDown(300);
				$chevron.addClass('rotate-180');
				$button.attr('aria-expanded', 'true');
			}
		});

		// Reset mobile menu state function
		function resetMobileMenuState() {
			// Close all accordions
			$('.mobile-menu-accordion-content').hide();
			$('.mobile-menu-accordion-button').attr('aria-expanded', 'false');
			$('.mobile-menu-accordion-icon-plus').removeClass('hidden');
			$('.mobile-menu-accordion-icon-minus').addClass('hidden');

			// Close all dropdowns
			$('.mobile-menu-dropdown').hide();
			$('.mobile-menu-header-button, .mobile-menu-footer-button').attr('aria-expanded', 'false');
			$('.mobile-menu-header-button img, .mobile-menu-footer-button img').removeClass('rotate-180');
		}
	});
}

